import React from "react";
import "./AnnouncementCard.css";

interface AnnouncementCardProps {
  image: string;
  title: string;
  link: string;
  onReadMore?: () => void;
}

const AnnouncementCard: React.FC<AnnouncementCardProps> = ({
  image,
  title,
  link,

  onReadMore,
}) => (
  <div className="announcement-card">
    <div className="announcement-card-img-wrapper">
      <img src={image} alt={title} className="announcement-card-img" />
      <button
        type="button"
        className="announcement-card-readmore"
        onClick={() => {
          if (onReadMore) onReadMore();
        }}
      >
        Register Now
      </button>
    </div>
  </div>
);

export default AnnouncementCard;
